import React from "react";
import { Pagination, Stack } from "@mui/material";

const PaginatedList = ({ totalPages, currentPage, onPageChange }) => {
  return (
    <Stack spacing={2} alignItems="center" mt={2}>
      <Pagination
        count={totalPages}
        page={currentPage}
        onChange={(event, value) => onPageChange(value)}
        color="primary"
      />
    </Stack>
  );
};

export default PaginatedList;
